const contentBarControls = () => {
    if (document.querySelector('.kruse-section-block--trigger')) {
        document.addEventListener('click', ev => {
            if (!ev.target.closest('.kruse-section-block--trigger')) return;
            ev.preventDefault();
            const bar = document.querySelector('.kruse-section-block--anchor-holder');
            let markerLinks = bar.querySelectorAll('.kruse-section-block--anchor-holder--marker');
            bar.classList.toggle('kruse-section-block--anchor-holder-extended');
            if (bar.classList.contains('kruse-section-block--anchor-holder-extended')) {
               markerLinks.forEach(m => {
                    m.setAttribute('tabindex', '0');
                })
                markerLinks[0].focus();
            } else {
                markerLinks.forEach(m => {
                    m.setAttribute('tabindex', '-1');
                })
                ev.target.closest('.kruse-section-block--trigger').focus();
            }

        })
    }
}
export default contentBarControls;